import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const AdminRoute = ({ children }) => {
  const { token, user } = useSelector((s) => s.auth);
  if (!token || user?.role !== 'admin') return <Navigate to="/admin/login" replace />;
  return children;
};

export default AdminRoute;
